// Aturan No. HP peserta WNI -- cermin backend/nomor_hp.py (angka & pesan sama persis).
export const PANJANG_MIN_NO_HP = 10;
export const PANJANG_MAKS_NO_HP = 13;
export const CONTOH_NO_HP = "081234567890";
export const BANTUAN_NO_HP = `Diawali 08, ${PANJANG_MIN_NO_HP}–${PANJANG_MAKS_NO_HP} digit, tanpa spasi atau tanda hubung.`;

export const PESAN_DUA_NOMOR = "No. HP hanya boleh berisi satu nomor";
export const PESAN_BUKAN_ANGKA = `No. HP hanya boleh berisi angka (contoh ${CONTOH_NO_HP})`;
export const PESAN_AWALAN = `No. HP harus diawali 08 (contoh ${CONTOH_NO_HP})`;
export const pesanPanjang = (n) => `No. HP harus ${PANJANG_MIN_NO_HP}–${PANJANG_MAKS_NO_HP} digit (sekarang ${n} digit)`;

const PEMISAH = /[\s\-.()]/g;
const PEMISAH_NOMOR = /[/,;|&\n]|\b(?:atau|dan|or)\b/i;
const KARAKTER_SAH = /^[0-9+\s\-.()]*$/;
const AWAL_NOMOR = /^(?:\+?62|0?8)\d{7,}$/;
// Karakter tak terlihat & tanda hubung khusus yg ikut tersalin dari kontak ponsel/WhatsApp.
const TAK_TERLIHAT = /[​-‏‪-‮⁠﻿]/g;
const HUBUNG_KHUSUS = /[‐-―−]/g;

export function berisiLebihDariSatuNomor(teks) {
    if (PEMISAH_NOMOR.test(teks)) return true;
    const potongan = teks.split(/\s+/).filter(Boolean).map((p) => p.replace(/[-.()]/g, ""));
    return potongan.filter((p) => AWAL_NOMOR.test(p)).length >= 2;
}

// { nilai, galat }: nilai = nomor rapi ("" bila kosong), galat = pesan atau null.
export function periksaNoHp(masukan) {
    const teks = String(masukan ?? "").trim();
    if (!teks) return { nilai: "", galat: null };
    if (berisiLebihDariSatuNomor(teks)) return { nilai: teks, galat: PESAN_DUA_NOMOR };
    if (!KARAKTER_SAH.test(teks)) return { nilai: teks, galat: PESAN_BUKAN_ANGKA };
    let nomor = teks.replace(PEMISAH, "");
    if (nomor.startsWith("+62")) nomor = "0" + nomor.slice(3);
    else if (nomor.startsWith("62")) nomor = "0" + nomor.slice(2);
    else if (nomor.startsWith("8")) nomor = "0" + nomor;
    if (/^\+\d+$/.test(nomor)) return { nilai: teks, galat: PESAN_AWALAN }; // kode negara selain +62
    if (!/^\d+$/.test(nomor)) return { nilai: teks, galat: PESAN_BUKAN_ANGKA };
    if (!nomor.startsWith("08")) return { nilai: teks, galat: PESAN_AWALAN };
    if (nomor.length < PANJANG_MIN_NO_HP || nomor.length > PANJANG_MAKS_NO_HP) return { nilai: teks, galat: pesanPanjang(nomor.length) };
    return { nilai: nomor, galat: null };
}

// Nomor yg ditempel: buang tanda tak terlihat, spasi & tanda hubung; bila jadi satu nomor sah, pakai bentuk rapinya.
// Dua nomor atau lebih dibiarkan apa adanya supaya pesan galatnya tampil (tidak dipotong diam-diam).
export function bersihkanTempelanNoHp(teks) {
    const tanpaTanda = String(teks ?? "").replace(TAK_TERLIHAT, "").replace(HUBUNG_KHUSUS, "-").trim();
    if (berisiLebihDariSatuNomor(tanpaTanda)) return tanpaTanda;
    const hasil = periksaNoHp(tanpaTanda);
    return hasil.galat ? tanpaTanda.replace(/[\s-]/g, "") : hasil.nilai;
}

// Galat utk isian form: hanya WNI, dan saat edit hanya bila nomor diubah dari yg tersimpan.
export function galatNoHpForm(nilai, kewarganegaraan, tersimpan) {
    if ((kewarganegaraan || "WNI") === "WNA") return null;
    if (tersimpan !== undefined && String(nilai ?? "") === String(tersimpan ?? "")) return null;
    return periksaNoHp(nilai).galat;
}
